document.addEventListener('DOMContentLoaded', function () {
  if (location.pathname.includes('bedruckte-armbander-fertig-konfektioniert')) return;

  var ribbon = document.querySelector('.preview-ribbon');
  if (!ribbon) return;

  function clearRepeat() {
    ribbon.querySelectorAll('[data-satin-repeat]').forEach(function (node) {
      node.remove();
    });
  }

  function updatePreview() {
    clearRepeat();
    // "Zwischen den Texten" already creates a second text motif. Repeat the
    // logo(s) after that text so the sequence reads: text – logo – text – logo.
    var repeatedText = ribbon.querySelector('.preview-text-repeat');
    if (repeatedText) {
      var currentNodes = Array.from(ribbon.children);
      var firstTextIndex = currentNodes.findIndex(function (node) {
        return node.classList.contains('preview-text');
      });
      var repeatedTextIndex = currentNodes.indexOf(repeatedText);
      var betweenNodes = currentNodes.slice(firstTextIndex + 1, repeatedTextIndex);
      betweenNodes.forEach(function (node) {
        var clone = node.cloneNode(true);
        clone.dataset.satinRepeat = 'true';
        ribbon.appendChild(clone);
      });
      requestAnimationFrame(function () {
        window.dispatchEvent(new Event('resize'));
      });
      return;
    }
    var originals = Array.from(ribbon.children);
    originals.forEach(function (node, index) {
      var clone = node.cloneNode(true);
      clone.dataset.satinRepeat = 'true';
      if (index === 0) clone.classList.add('satin-repeat-start');
      ribbon.appendChild(clone);
    });
    requestAnimationFrame(function () {
      window.dispatchEvent(new Event('resize'));
    });
  }

  window.addEventListener('band:logos-rendered', updatePreview);
  updatePreview();
});
